import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpen, CheckCircle2 } from 'lucide-react';
export function ChapterPreview() {
  const chapters = [{
    num: '1',
    title: 'La Verdad sobre su Rodilla',
    desc: "Por qué el dolor no es solo 'edad'."
  }, {
    num: '2',
    title: 'El Botiquín Oculto',
    desc: '5 elementos de su cocina que apagan el incendio del dolor.'
  }, {
    num: '3',
    title: 'El Protocolo de 7 Días',
    desc: 'Menú y hábitos de choque anti-inflamatorio.'
  }, {
    num: '4',
    title: 'Movilidad de Oro',
    desc: '3 estiramientos que puede hacer sentada en su sillón.'
  }, {
    num: '5',
    title: 'La Compresión Nocturna',
    desc: 'Cómo preparar su rodilla para un despertar sin pinchazos.'
  }];
  const tools = ["Lista de compras 'Inflamación Cero'", 'Diario de escala de dolor diario', 'Guía visual de compresión casera'];
  return <section className="py-20 px-6 bg-brand-beige" data-id="element-23">
      <div className="max-w-4xl mx-auto" data-id="element-24">
        <FadeIn data-id="element-25">
          <div className="text-center mb-16" data-id="element-26">
            <BookOpen className="w-12 h-12 text-brand-terracotta mx-auto mb-6" data-id="element-27" />
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-brown" data-id="element-28">
              ¿Qué Encontrará Dentro?
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-4 mb-16" data-id="element-29">
          {chapters.map((chapter, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-30">
              <div className="bg-white p-6 md:p-8 rounded-xl shadow-sm flex flex-col md:flex-row items-start gap-4 md:gap-6 border-l-4 border-brand-sage" data-id="element-31">
                <div className="text-3xl font-serif font-bold text-brand-sage opacity-50 mt-1" data-id="element-32">
                  0{chapter.num}
                </div>
                <div data-id="element-33">
                  <h3 className="text-xl font-bold text-brand-brown mb-2" data-id="element-34">
                    {chapter.title}
                  </h3>
                  <p className="text-brand-dark text-lg" data-id="element-35">{chapter.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-36">
          <div className="bg-brand-light p-8 md:p-10 rounded-2xl border border-brand-sage border-opacity-30" data-id="element-37">
            <h3 className="text-2xl font-serif font-bold text-brand-brown mb-8 text-center" data-id="element-38">
              Herramientas Prácticas Incluidas
            </h3>
            <ul className="space-y-5 max-w-2xl mx-auto" data-id="element-39">
              {tools.map((tool, idx) => <li key={idx} className="flex items-center gap-4 text-lg text-brand-dark" data-id="element-40">
                  <CheckCircle2 className="w-6 h-6 text-brand-sage flex-shrink-0" data-id="element-41" />
                  <span data-id="element-42">{tool}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}